import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const customerEmailListSlice = createApi({
    reducerPath: "customerEmailList",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://brand-logistics.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    refetchOnMountOrArgChange: true,
    endpoints: (builder) => ({
        customerEmailList: builder.query({
            query: (data) => ({ url: "/order-management/api/v1/email/list", params: data, method: "GET" }),
        }),
    }),
});

export const { useCustomerEmailListQuery } = customerEmailListSlice;
